import { render, staticRenderFns } from "./NewSalesOrderDocumentPage.vue?vue&type=template&id=5a8225c2&scoped=true"
import script from "./NewSalesOrderDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewSalesOrderDocumentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8225c2",
  null
  
)

export default component.exports